export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/DE-5c449284c8bffd8a1a7b5cea411206cb.png";